import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/icons/filter-icon.svg'
import _imports_1 from '../../../assets/icons/trade-network-search.svg'
import _imports_2 from '../../../assets/icons/trade-network-location.svg'
import _imports_3 from '../../../assets/icons/trade-network-trader.svg'
import _imports_4 from '../../../assets/icons/trade-network-list.svg'
import _imports_5 from '../../../assets/icons/sort.svg'
import _imports_6 from '../../../assets/icons/project-status.svg'


const _withScopeId = n => (_pushScopeId("data-v-9b79de52"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mobile__wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "All Filters", -1))
const _hoisted_4 = { class: "project-listing__filter" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1))
const _hoisted_10 = { class: "project__header md:!tw-mt-0" }
const _hoisted_11 = { class: "project-listing__filter desktop__wrapper" }
const _hoisted_12 = { class: "left__block" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_15 = { class: "project-listing-innertabs right__block" }
const _hoisted_16 = { class: "two_icons" }
const _hoisted_17 = { class: "sort__wrapper sort_dropdown_wrapper" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sortby_btn" }, "Sort by", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: ""
}, null, -1))
const _hoisted_20 = { class: "checked__wrapper" }
const _hoisted_21 = { class: "project-listing__filter desktop__wrapper" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_6 }, null, -1))
const _hoisted_23 = ["src"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1))
const _hoisted_26 = {
  key: 0,
  class: "tw-flex tw-flex-col tw-justify-center tw-items-center tw-h-full tw-w-full tw-mt-[500px]"
}
const _hoisted_27 = {
  key: 0,
  class: "top_project_listing"
}
const _hoisted_28 = { class: "top_list_details" }
const _hoisted_29 = { class: "project_main map_wrapper" }
const _hoisted_30 = {
  key: 0,
  class: "tw-absolute tw-bottom-[100px] tw-left-1/2 -tw-translate-1/2"
}
const _hoisted_31 = {
  key: 0,
  class: "map__container tw-rounded-xl tw-overflow-hidden"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_ProjectCard = _resolveComponent("ProjectCard")!
  const _component_PropertyMapModal = _resolveComponent("PropertyMapModal")!

  return (_openBlock(), _createElementBlock("div", {
    onScroll: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => ($setup.onScroll && $setup.onScroll(...args))),
    class: "project-listing-container scroll-container"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_expansion_panels, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_expansion_panel, null, {
            title: _withCtx(() => [
              _hoisted_2,
              _hoisted_3
            ]),
            default: _withCtx(() => [
              _createVNode(_component_v_expansion_panel_text, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_v_text_field, {
                      modelValue: $setup.filter.search,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.filter.search) = $event)),
                      placeholder: "Search Project name, Type, Description",
                      class: "input_field",
                      "bg-color": "#fff",
                      variant: "outlined"
                    }, {
                      "prepend-inner": _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_v_text_field, {
                      placeholder: "KT19 9JG",
                      class: "input_field",
                      "bg-color": "#fff",
                      variant: "outlined",
                      modelValue: $setup.filter.postcode,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.filter.postcode) = $event))
                    }, {
                      "prepend-inner": _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_v_select, {
                      items: $setup.projectStatusItems,
                      "item-title": "text",
                      "item-value": "value",
                      modelValue: $setup.filter.projectJobStatus,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.filter.projectJobStatus) = $event)),
                      class: "input_field",
                      "bg-color": "#fff",
                      variant: "outlined",
                      placeholder: "Project Status",
                      clearable: ""
                    }, {
                      item: _withCtx(({ props, item }) => [
                        _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              class: "service-icon-wrapper__icon",
                              src: require(`@/assets/icons/${item.raw.icon}.svg`),
                              alt: "icon"
                            }, null, 8, _hoisted_7)
                          ]),
                          _: 2
                        }, 1040)
                      ]),
                      _: 1
                    }, 8, ["items", "modelValue"]),
                    _createVNode(_component_v_select, {
                      modelValue: $setup.filter.propertyCategory,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.filter.propertyCategory) = $event)),
                      class: "input_field",
                      "bg-color": "#fff",
                      variant: "outlined",
                      placeholder: "Commercial / Residential",
                      items: $setup.propertyTypeItems,
                      "item-title": "text",
                      "item-value": "value",
                      clearable: ""
                    }, {
                      "prepend-inner": _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    }, 8, ["modelValue", "items"]),
                    _createVNode(_component_v_select, {
                      modelValue: $setup.filter.type,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.filter.type) = $event)),
                      class: "input_field",
                      "bg-color": "#fff",
                      variant: "outlined",
                      placeholder: "Commercial / Residential",
                      items: $setup.jobTypes,
                      "item-title": "text",
                      "item-value": "value"
                    }, {
                      "prepend-inner": _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    }, 8, ["modelValue", "items"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_v_text_field, {
            modelValue: $setup.filter.search,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.filter.search) = $event)),
            placeholder: "Search Project name, Type, Description",
            class: "input_field",
            "bg-color": "#fff",
            variant: "outlined"
          }, {
            "prepend-inner": _withCtx(() => [
              _hoisted_13
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_v_text_field, {
            placeholder: "KT19 9JG",
            class: "input_field small__width",
            "bg-color": "#fff",
            variant: "outlined",
            modelValue: $setup.filter.postcode,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.filter.postcode) = $event)),
            width: "143px"
          }, {
            "prepend-inner": _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", {
              class: _normalizeClass(["right_btn", { active: !$setup.isMapView }])
            }, [
              _createVNode(_component_v_btn, {
                "prepend-icon": "mdi-view-grid",
                variant: "text",
                onClick: $setup.onClickTileMapBtn
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Tile ")
                ]),
                _: 1
              }, 8, ["onClick"])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["right_btn", { active: $setup.isMapView }])
            }, [
              _createVNode(_component_v_btn, {
                "prepend-icon": "mdi-map",
                variant: "text",
                onClick: $setup.onClickTileMapBtn
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Map ")
                ]),
                _: 1
              }, 8, ["onClick"])
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createVNode(_component_v_menu, { "close-on-content-click": false }, {
              activator: _withCtx(({ props }) => [
                _createVNode(_component_v_btn, _mergeProps(props, { class: "sort__btn" }), {
                  default: _withCtx(() => [
                    _hoisted_19
                  ]),
                  _: 2
                }, 1040)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_v_list, { class: "dropdown__sort sort_dropdown_inner" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filterOptions, (item) => {
                      return (_openBlock(), _createBlock(_component_v_list_item, {
                        key: item.value
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, { onClick: $setup.onClickFilterOption }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                icon: item.icon,
                                width: "12"
                              }, null, 8, ["icon"]),
                              _createTextVNode(" " + _toDisplayString(item.label) + " ", 1),
                              _createElementVNode("span", _hoisted_20, [
                                _createVNode(_component_v_icon, { icon: "mdi-check" })
                              ])
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }),
                ($setup.isShowDatePicker)
                  ? (_openBlock(), _createBlock(_component_DatePicker, {
                      key: 0,
                      masks: $setup.masks,
                      class: "calendar__select calendar__select__custom",
                      modelValue: $setup.filter.dataRange,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.filter.dataRange) = $event)),
                      modelModifiers: { range: true },
                      mode: "date"
                    }, null, 8, ["masks", "modelValue"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createVNode(_component_v_select, {
          items: $setup.projectStatusItems,
          "item-title": "text",
          "item-value": "value",
          modelValue: $setup.filter.projectJobStatus,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.filter.projectJobStatus) = $event)),
          class: "input_field",
          "bg-color": "#fff",
          variant: "outlined",
          placeholder: "Project Status",
          clearable: "",
          "menu-props": { contentClass: 'icon__text__select' }
        }, {
          "prepend-inner": _withCtx(() => [
            _hoisted_22
          ]),
          item: _withCtx(({ props, item }) => [
            _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  class: "service-icon-wrapper__icon",
                  src: require(`@/assets/icons/${item.raw.icon}.svg`),
                  alt: "icon"
                }, null, 8, _hoisted_23)
              ]),
              _: 2
            }, 1040)
          ]),
          _: 1
        }, 8, ["items", "modelValue"]),
        _createVNode(_component_v_select, {
          modelValue: $setup.filter.propertyCategory,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.filter.propertyCategory) = $event)),
          class: "input_field",
          "bg-color": "#fff",
          variant: "outlined",
          placeholder: "Commercial / Residential",
          items: $setup.propertyTypeItems,
          "item-title": "text",
          "item-value": "value",
          "menu-props": { contentClass: 'icon__text__select' },
          clearable: ""
        }, {
          "prepend-inner": _withCtx(() => [
            _hoisted_24
          ]),
          _: 1
        }, 8, ["modelValue", "items"]),
        _createVNode(_component_v_select, {
          modelValue: $setup.filter.type,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.filter.type) = $event)),
          class: "input_field",
          "bg-color": "#fff",
          variant: "outlined",
          placeholder: "Project Type",
          items: $setup.jobTypes,
          "item-title": "text",
          "item-value": "value",
          clearable: "",
          "menu-props": { contentClass: 'icon__text__select' }
        }, {
          "prepend-inner": _withCtx(() => [
            _hoisted_25
          ]),
          _: 1
        }, 8, ["modelValue", "items"])
      ])
    ]),
    ($setup.IsLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _createVNode(_component_Loader, { show: $setup.IsLoading }, null, 8, ["show"])
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (!$setup.isEmptyPropertiesList)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", null, _toDisplayString($setup.getProjectCount) + " Projects", 1),
                  _createTextVNode(" | "),
                  _createElementVNode("div", null, _toDisplayString($setup.getProjectCount) + " Results", 1)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(["top_project_listing_content", { show: $setup.isMapView }])
          }, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", {
                class: _normalizeClass(["full_container", { half_container: $setup.isMapView }])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.projectListing, (item) => {
                  return (_openBlock(), _createBlock(_component_ProjectCard, {
                    key: item.id,
                    job: item,
                    onClick: ($event: any) => ($setup.onClickProject(item?.refId, item.type)),
                    highlightProject: $setup.highlightProjectIds.has(item?.id)
                  }, null, 8, ["job", "onClick", "highlightProject"]))
                }), 128))
              ], 2),
              ($setup.isLoadingMorePage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _createVNode(_component_Loader, { show: $setup.isLoadingMorePage }, null, 8, ["show"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            ($setup.addresses && $setup.addresses.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _createVNode(_component_PropertyMapModal, {
                    properties: $setup.parsedPropertyList,
                    onOnClickMarker: $setup.highlightProject
                  }, null, 8, ["properties", "onOnClickMarker"])
                ]))
              : _createCommentVNode("", true)
          ], 2)
        ], 64))
  ], 32))
}